import React from 'react';
import BodyTypography from '../../../../Common/BodyTypography';
import GridRowNode from '../Common/GridRowNode';

interface ReasonItemProps {
    title: string;
    value: string;
}
function ReasonItem({ title, value }: ReasonItemProps): React.JSX.Element {
    return (
        <GridRowNode
            title={<BodyTypography>{title}:</BodyTypography>}
            node={<BodyTypography>{value}</BodyTypography>}
        />
    );
}

export default ReasonItem;
